module.exports = __webpack_public_path__ + "img/salespersonXinZeng.f4e0617f.png";